import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const OrderNumberCellContent: React.FC<OrderNumberCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.OrderNumber];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item.orderNumber);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.orderNumber,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace OrderNumberCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default OrderNumberCellContent;
